import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import {systemOptionsTags} from 'helpers/dataHelpers.jsx';
import getProductDict from 'page/customer/system/productDict.js';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import get from 'lodash/get';
import {languages} from 'helpers/languageHelper';

class printableCustomerReport extends React.Component {
  static propTypes = {
    customer: PropTypes.object,
    dealer: PropTypes.object,
    products: PropTypes.array,
    intl: intlShape.isRequired,
  };

  state = {
    display: null,
  };

  getProductName = (id) => {
    let product = this.props.products.filter(x => x.id === id)[0];

    return product && product.name ? product.name : '';
  };

  render() {
    return (
      <div id='page-customer'
           className='container'>
        <h2 style={{marginBottom: '15px', marginLeft: '-18px'}}>{this.props.customer.organization}
          <FormattedMessage id='general.water.profile'/></h2>
        <div className='row'
             style={{marginBottom: '15px'}}>
          <div className='col-xs-4'>
            <div className='form-group'>
              <label style={{fontWeight: 'bold'}}><FormattedMessage id='general.owner'/>/<FormattedMessage id='general.operator'/></label>
              <div>{this.props.customer.organization}</div>
            </div>
          </div>
          <div className='col-xs-4'>
            <div className='form-group'>
              <label style={{fontWeight: 'bold'}}><FormattedMessage id='general.address'/></label>
              <div>{this.props.customer.address1}</div>
              <div>{this.props.customer.address2}</div>
              <div>{this.props.customer.city}, {this.props.customer.state} {this.props.customer.zip}</div>
              <div>{this.props.customer.country}</div>
            </div>
          </div>
          {/*<div className='col-xs-4'>*/}
          {/*<div className='form-group'>*/}
          {/*<label style={{fontWeight: 'bold'}}><FormattedMessage id='general.customer.type'/></label>*/}
          {/*<div>{this.props.customer.customerType}</div>*/}
          {/*</div>*/}
          {/*</div>*/}
        </div>
        <h3 style={{marginBottom: '15px'}}><FormattedMessage id='general.contacts'/></h3>
        <table className='table table-striped'
               style={{width: '100%'}}>
          <thead>
            <tr>
              <th style={{textAlign: 'left'}}><FormattedMessage id='general.name'/></th>
              <th style={{textAlign: 'left'}}><FormattedMessage id='general.email'/></th>
              <th style={{textAlign: 'left'}}><FormattedMessage id='general.primary'/></th>
              <th style={{textAlign: 'left'}}><FormattedMessage id='general.alternate'/></th>
              <th style={{textAlign: 'left'}}><FormattedMessage id='general.alternate'/></th>
            </tr>
          </thead>
          <tbody>
            {this.props.customer.customerContacts.map(cc =>
              <tr key={cc.id + cc.nameFirst}>
                <td>{cc.nameFirst} {cc.nameLast}</td>
                <td>{cc.email}</td>
                <td>{cc.homePhone}</td>
                <td>{cc.workPhone}</td>
                <td>{cc.mobilePhone}</td>
              </tr>
          )}
          </tbody>
        </table>

        <h3 style={{marginBottom: '15px'}}><FormattedMessage id='general.systems'/></h3>
        {this.props.customer.pools.map((p, i) => <PoolSummary key={i}
                                                              locale={this.props.locale}
                                                              pool={p}
                                                              products={this.props.products}
                                                              dealer={this.props.dealer}
                                                              formatMessage={this.props.intl.formatMessage}/>)}
      </div>
    );
  }
}

const SummaryField = ({value, label}) => {
  if (!value) {
    return <div/>;
  }

  if (value === true || value === 'true') {
    value = <FormattedMessage id='general.yes' />;
  }

  return (
    <div style={{marginBottom: 10, float: 'left', width: '33%'}}
         className='pool-printable-summary-field'>
      <label style={{color: 'black', fontWeight: 600}}>{label}</label>
      {value === '&nbsp;' ?
        <div dangerouslySetInnerHTML={{__html: value}}/> :
        <div>{value}</div>}
    </div>
  );
};

const SummaryHeader = ({poolType, prevAnalysisDate, formatMessage, locale}) => {
  let date = prevAnalysisDate ? moment(prevAnalysisDate).locale(languages[locale].time).format('ll') : formatMessage({id: 'general.none'});

  return <div style={{
    width: '100%',
    backgroundColor: '#d8d8d8',
    borderBottom: '1px solid #000',
    fontSize: 16,
    fontWeight: 600,
    padding: 10,
  }}
              className='pool-printable-summary-header'>
    {poolType} (<FormattedMessage id='general.last.analysis'/>: {date})
  </div>;
};

const HorizontalRule = () => {
  return <div style={{width: '100%', backgroundColor: 'black', height: 1, float: 'left', marginTop: 5, marginBottom: 5}}
              className='pool-printable-summary-hr'/>;
};

const PoolSummary = ({pool, products, dealer, formatMessage, locale}) => {

  let {productDict} = getProductDict({pool, products, dealer, formatMessage});
  let volume = '';
  let optLabel = '';

  if (dealer && dealer.country && dealer.country.toLowerCase() === 'ca') {
    volume = pool.volume + ' ' + formatMessage({id: 'quick-calcs.volume.litres'});
    optLabel = formatMessage({id: 'general.using.optimizer.plus'});
  } else {
    volume = pool.volume + ' ' + formatMessage({id: 'quick-calcs.volume.gals'});
    optLabel = formatMessage({id: 'general.using.optimizer'});
  }

  const getValue = key => {
    const tag = pool && pool.typeID && key && pool[key] ? get(systemOptionsTags, [pool.typeID, key, pool[key]]) : undefined;

    return tag ? formatMessage({id: tag}) : '';
  };

  return <div className='pool-printable-summary'
              style={{border: '2px solid black', marginTop: 15, marginBottom: 15}}
              key={'poolSummary' + pool.id}>
    <SummaryHeader poolType={pool.typeID === 1 ?
      formatMessage({id: 'general.pool'}) :
      pool.typeID === 2 ?
        formatMessage({id: 'general.spa'}) :
        formatMessage({id: 'general.swim.spa'})}
                   prevAnalysisDate={pool.prevAnalysisDate}
                   locale={locale}
                   formatMessage={formatMessage}/>

    <div style={{padding: 10}}>
      <SummaryField label={formatMessage({id: 'general.volume'})}
                    value={volume + '.'}/>
      <SummaryField label={formatMessage({id: 'general.location'})}
                    value={getValue('location')}/>
      <SummaryField label={formatMessage({id: 'general.finish'})}
                    value={getValue('finish')}/>
      <SummaryField label={formatMessage({id: 'general.ground.level'})}
                    value={getValue('groundLevel')}/>
      <SummaryField label={formatMessage({id: 'general.residential'}) + '/' + formatMessage({id: 'general.commercial'})}
                    value={getValue('property')}/>
      <SummaryField label={formatMessage({id: 'general.filter.media'})}
                    value={getValue('filterMedia')}/>
      <SummaryField label={formatMessage({id: 'system.details.vacuum.waste'})}
                    value={pool.cannotVacToWaste}/>

      <HorizontalRule/>

      <SummaryField label={formatMessage({id: 'system.details.jetted.returns'})}
                    value={pool.jettedReturns}/>
      <SummaryField label={formatMessage({id: 'system.details.ionization.catalyst'})}
                    value={pool.ionization}/>
      <SummaryField label={formatMessage({id: 'system.details.attached.spa'})}
                    value={pool.attachedSpa}/>
      <SummaryField label={formatMessage({id: 'general.infloor.cleaner'})}
                    value={pool.infloorCleaner}/>
      <SummaryField label={formatMessage({id: 'system.details.water.fountain'})}
                    value={pool.waterFountain}/>
      <SummaryField label={formatMessage({id: 'general.waterfall'})}
                    value={pool.waterfall}/>
      <SummaryField label={formatMessage({id: 'general.ozonator'})}
                    value={pool.ozonator}/>

      <HorizontalRule/>

      <SummaryField label={formatMessage({id: 'general.sanitizer'})}
                    value={productDict.sanitizer.currentName}/>
      <SummaryField label={formatMessage({id: 'general.maint.oxidizer'})}
                    value={productDict.maintOxidizer.currentName}/>
      <SummaryField label={formatMessage({id: 'general.prev.algicide'})}
                    value={productDict.prevAlgicide.currentName}/>
      <SummaryField label={formatMessage({id: 'general.oxidizer'})}
                    value={productDict.oxidizer.currentName}/>
      <SummaryField label={formatMessage({id: 'customer.product.profile.phadjuster'})}
                    value={productDict.pHAdjuster.currentName}/>
      <SummaryField label={formatMessage({id: 'general.ph.buffer'})}
                    value={productDict.pHBuffer.currentName}/>
      <SummaryField label={formatMessage({id: 'general.maint.clarifier'})}
                    value={productDict.maintClarifier.currentName}/>

      <HorizontalRule/>

      <SummaryField label={optLabel}
                    value={pool.usingOptimizerPlus}/>
      <SummaryField label={formatMessage({id: 'chemicals.using.vanishing.act'})}
                    value={pool.usingVanishingAct}/>
      <SummaryField label={formatMessage({id: 'chemicals.natural.spa.enzyme'})}
                    value={pool.enzymes}/>
      {/*      <SummaryField label='Oxysheen' value={pool.oxysheenTreatment} /> */}
      <SummaryField label={formatMessage({id: 'chemicals.softsoak.trio'})}
                    value={pool.softSoakTRIO}/>
      <SummaryField label={formatMessage({id: 'general.ideal.mineral'}) + '/' + formatMessage({id: 'general.salt.ppm'})}
                    value={pool.idealSaltPPM}/>
      <div style={{clear: 'both'}}/>
    </div>
  </div>;
};

export default injectIntl(printableCustomerReport);
